import React, { useEffect } from "react";
import { Star, Puzzle, Car, Sword } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import logo from '../Img/logo.png'
import { TbBrandYoutubeFilled } from "react-icons/tb";

const Footer = () => {
  const location = useLocation();

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-out-cubic",
      once: true,
      offset: 100
    });
  }, [location.pathname]);

  return (
    <footer
      className="relative overflow-hidden bg-gradient-to-br lg:px-8 from-gray-900 via-black to-gray-800 text-gray-300 sm:pt-16 pt-9 md:pb-8 pb-[85px]"
    >
      <div className="container mx-auto px-4">
        
        <div
          className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          
          <div className="sm:col-span-2 md:col-span-2 lg:col-span-2" data-aos="fade-right">
            <div className="flex items-center space-x-3 mb-4">
              <img src={logo} className="sm:w-16 sm:h-16 h-12 w-12 text-purple-500 drop-shadow-lg object-cover" alt="Game Zone Hub Logo" loading="lazy" />
              <span className="font-bold sm:text-2xl text-[22px] bg-gradient-to-r from-[#9b4dff] via-[#e056fd] to-[#00eaff] text-transparent bg-clip-text">
                Game Zone Hub
              </span>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed max-w-md">
              Game Zone Hub is your ultimate, ad-lite destination to play free online games. We leverage advanced HTML5 and WebGL technology to bring you console-quality entertainment directly in your web browser. Whether you are looking for high-speed 3D racing, intense multiplayer action, or mind-bending logic puzzles, our curated library has it all. No downloads, no installations, and no hidden fees—just instant gaming access on desktop, tablet, and mobile devices.
            </p>
          </div>

          <div data-aos="fade-up" data-aos-delay="150">
            <h2 className="font-semibold text-lg text-white mb-4">Quick Links</h2>
            <ul className="space-y-3">
              <li><Link to="/about" className="hover:text-purple-400 transition" aria-label="About Game Zone Hub">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-purple-400 transition" aria-label="Contact Support">Contact Us</Link></li>
              <li><Link to="/privacy-policy" className="hover:text-purple-400 transition" aria-label="Privacy Policy">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-purple-400 transition" aria-label="Terms and Conditions">Terms & Conditions</Link></li>
              <li className="flex items-center cursor-pointer hover:text-purple-400 transition">
                <a href="https://www.youtube.com/@dhruvingamingchannel7727" target="_blank" rel="noopener noreferrer" aria-label="Game Zone Hub YouTube Channel" className="flex items-center">
                  <TbBrandYoutubeFilled className="text-red-500 text-3xl me-2" aria-hidden="true" />
                  <span className="text-[14px] font-bold">YouTube</span>
                </a>
              </li>
            </ul>
          </div>

          <div data-aos="fade-left" data-aos-delay="200">
            <h2 className="font-semibold text-lg text-white mb-4">Popular Categories</h2>
            <ul className="space-y-3">
              <li className="hover:text-purple-400 transition">
                <Link to="/games" className="flex items-center gap-2" aria-label="Play Action Games">
                  <Sword className="w-5 h-5" aria-hidden="true" /> Action
                </Link>
              </li>
              <li className="hover:text-purple-400 transition">
                <Link to="/games" className="flex items-center gap-2" aria-label="Play Puzzle Games">
                  <Puzzle className="w-5 h-5" aria-hidden="true" /> Puzzle
                </Link>
              </li>
              <li className="hover:text-purple-400 transition">
                <Link to="/games" className="flex items-center gap-2" aria-label="Play Racing Games">
                  <Car className="w-5 h-5" aria-hidden="true" /> Racing
                </Link>
              </li>
              <li className="hover:text-purple-400 transition">
                <Link to="/games" className="flex items-center gap-2" aria-label="Play Adventure Games">
                  <Star className="w-5 h-5" aria-hidden="true" /> Adventure
                </Link>
              </li>
            </ul>
          </div>

        </div>

        <div
          className="border-t border-gray-700 sm:mt-12 mt-8 pt-6 text-center text-sm text-gray-400"
        >
          © {new Date().getFullYear()} Game Zone Hub. All rights reserved.
          <span className="block md:inline md:ml-2">Level Up Your Fun with Free Online Games 🚀</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;